import { Capacitor } from "@capacitor/core";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { DownloadIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import { toast } from "sonner";
import Image, { transformImgSrc } from "./Image";
import { Button } from "./ui/button";
import { AlcDrawer } from "./ui/drawer";

export default function PhotoPreview({
  open,
  setOpen,
  imgUrl,
  alt = "",
  dontTransform = false,
}) {
  const [saving, setSaving] = useState(false);

  const downloadImage = async () => {
    setSaving(true);
    try {
      let url = dontTransform ? imgUrl : transformImgSrc(imgUrl);
      let type = "png";
      if (!url.startsWith("data:")) {
        url = `${url}/download`;
      } else {
        const blob = await fetch(imgUrl).then((res) => res.blob());
        type = blob.type.split("/")[1];
      }

      if (Capacitor.isNativePlatform()) {
        const response = await fetch(url);
        const blob = await response.blob();
        const reader = new FileReader();
        reader.onload = () => {
          const base64 = reader.result as string;
          Filesystem.writeFile({
            path: `Alkulačka-${new Date()
              .toLocaleString()
              .replace(/[,:\s/]/g, "-")}.${type}`,
            data: base64,
            directory: Directory.Documents,
            recursive: true,
          })
            .then(() => {
              toast.success("Obrázek byl stažen.");
              setSaving(false);
            })
            .catch(() => {
              toast.error("Nepodařilo se stáhnout obrázek.");
              setSaving(false);
            });
        };
        reader.readAsDataURL(blob);
        return;
      }

      const a = document.createElement("a");
      a.href = url;
      a.setAttribute(
        "download",
        `Alkulačka-${new Date()
          .toLocaleString()
          .replace(/[,:\s/]/g, "-")}.${type}`
      );

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setSaving(false);
    } catch (e) {
      toast.error("Nepodařilo se stáhnout obrázek.");
      setSaving(false);
    }
  };

  return (
    <AlcDrawer isOpen={open} setIsOpen={setOpen}>
      <div
        style={{ paddingTop: "1rem", maxHeight: "100%", position: "relative" }}
      >
        <Image
          alt={alt}
          src={imgUrl}
          style={{
            height: "100%",
            maxHeight: "100%",
            width: "100%",
            objectFit: "contain",
            borderRadius: "0.5rem",
          }}
          dontTransform={dontTransform}
        />
        <Button
          size="icon"
          style={{ position: "absolute", top: "0", right: "0" }}
          onClick={downloadImage}
          disabled={saving}
        >
          <DownloadIcon />
        </Button>
      </div>
    </AlcDrawer>
  );
}
